import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/internal/Observable';
import {environment} from '../../../environments/environment';
import {OrderParameters} from '../interfaces/order-parameters';
import {UserLogin} from '../interfaces/user-login';
import {TransactionConfig} from '../interfaces/transaction-config';
import {GlobalIconMessages} from '../interfaces/global-icon-messages';
import {TransactionParameters} from '../interfaces/transaction-parameters';
import {YtSong, YtSongItems} from '../interfaces/yt-song';
import {of} from 'rxjs/internal/observable/of';


@Injectable({
  providedIn: 'root'
})
export class OrderPanelService {
  constructor(private readonly http: HttpClient) { }

  public checkUser(user: string): Observable<UserLogin> {
    const url = `${environment.url}/add-song/checkUser`;
    const params = {
      userLogin: user,
    };

    return this.http.get<UserLogin>(url, {params});
  }
  public getUserParameters(id: number): Observable<OrderParameters> {
    const url = `${environment.url}/add-song/getUserParameters`;
    const params = {
      userId: id
    };

    return this.http.get<OrderParameters>(url, {params});
  }
  public checkUserInput(transactionConfig: TransactionConfig): Observable<any> {
    const urlSearchParams = new URLSearchParams(transactionConfig.songUrl.split('?')[1]);
    const url = `${environment.url}/add-song/checkUserInput`;
    const list = urlSearchParams.get('list');
    const index = urlSearchParams.get('index');
    const params = {
      userId: transactionConfig.userId,
      songUrl: `https://www.youtube.com/watch?v=${urlSearchParams.get('v')}`,
      list,
      index,
      streamerName: transactionConfig.streamerName,
      userName: transactionConfig.userName,
      payAmount: transactionConfig.payAmount,
      description: `Donate ${transactionConfig.payAmount} RUB attaching song(s) ${urlSearchParams.get('v')} for streamer ${transactionConfig.streamerName}`,
      paymentNo: '',
      token: null,
      additionalParams: ''
    };

    return this.http.get<any>(url, {params});
  }
  public createTrans(transactionConfig: TransactionConfig): Observable<any> {
    const urlSearchParams = new URLSearchParams(transactionConfig.songUrl.split('?')[1]);
    const url = `${environment.url}/add-song/checkUserInputAndCreateTrans`;
    const params = {
      userId: transactionConfig.userId,
      songUrl: transactionConfig.songUrl,
      streamerName: transactionConfig.streamerName,
      userName: transactionConfig.userName,
      payAmount: transactionConfig.payAmount,
      description: `Donate ${transactionConfig.payAmount} RUB attaching song(s) ${urlSearchParams.get('v')} for streamer ${transactionConfig.streamerName}`,
      paymentNo: '',
      token: null,
      additionalParams: '',
      uniqueToken: transactionConfig.uniqueToken
    };

    return this.http.get<any>(url, {params});
  }

  public createRouletteTrans(transactionConfig: TransactionConfig): Observable<any> {
    const url = `${environment.url}/add-endless-roulette/checkUserInputAndCreateTrans`;
    const params = {
      userId: transactionConfig.userId,
      streamerName: transactionConfig.streamerName,
      userName: transactionConfig.userName,
      payAmount: transactionConfig.payAmount,
      message: transactionConfig.message,
      paymentNo: '',
      token: null,
      additionalParams: '',
      uniqueToken: transactionConfig.uniqueToken
    };

    return this.http.get<any>(url, {params});
  }

  public createClassicRouletteTrans(transactionConfig: TransactionConfig): Observable<any> {
    const url = `${environment.url}/add-classic-roulette/checkUserInputAndCreateTrans`;
    const params = {
      userId: transactionConfig.userId,
      streamerName: transactionConfig.streamerName,
      userName: transactionConfig.userName,
      payAmount: transactionConfig.payAmount,
      voteForValue: transactionConfig.voteForValue.name,
      paymentNo: '',
      token: null,
      additionalParams: '',
      uniqueToken: transactionConfig.uniqueToken
    };

    return this.http.get<any>(url, {params});
  }

  public createVoteListTrans(transactionConfig: TransactionConfig): Observable<any> {
    const url = `${environment.url}/add-vote-list/checkUserInputAndCreateTrans`;
    const params = {
      userId: transactionConfig.userId,
      streamerName: transactionConfig.streamerName,
      userName: transactionConfig.userName,
      payAmount: transactionConfig.payAmount,
      voteForValue: transactionConfig.voteForValue.name,
      paymentNo: '',
      token: null,
      additionalParams: '',
      uniqueToken: transactionConfig.uniqueToken
    };

    return this.http.get<any>(url, {params});
  }
  public checkClientAuth(token: string): Observable<any> {
    const url = `${environment.url}/add-song/checkClient`;
    const params = {
      token
    };

    return this.http.get<any>(url, {params});
  }
  public checkUserInputPromo(transactionParameters: TransactionParameters): Observable<any> {
    const url = `${environment.url}/add-song/checkUserInputPromo`;
    const params = {
      userId: transactionParameters.userId,
      songUrl: transactionParameters.songUrl,
      streamerName: transactionParameters.streamerName,
      userName: transactionParameters.userName,
      promoCode: transactionParameters.promoCode,
      token: transactionParameters.token,
      additionalParams: ''
    };

    return this.http.get<any>(url, {params});
  }
  public globalMessagesForStreamer(isStreamer: boolean): Observable<GlobalIconMessages[]> {
    const url = `${environment.url}/api/global-messages`;

    const params = {
      isStreamer,
    };

    return this.http.get<GlobalIconMessages[]>(url, {params});
  }
  public globalMessagesForUsers(isStreamer: boolean, clientToken: string): Observable<GlobalIconMessages[]> {
    const url = `${environment.url}/api/global-messages`;

    const params = {
      isStreamer,
      clientToken,
    };

    return this.http.get<GlobalIconMessages[]>(url, {params});
  }
  public globalMessagesForUserClosed(id: number, clientToken: string): Observable<any> {
    const url = `${environment.url}/api/global-messages/${id}/closed`;

    const params = {
      clientToken
    };

    return this.http.get<any>(url, {params});
  }
  public globalMessagesForAdminClosed(id: number): Observable<any> {
    const url = `${environment.url}/api/global-messages/${id}/closed`;

    return this.http.get<any>(url);
  }

  public checkUserInputMessage(transactionConfig: TransactionConfig): Observable<any> {
    const url = `${environment.url}/add-endless-roulette/checkUserInput`;

    const params = {
      userId: transactionConfig.userId,
      message: transactionConfig.message,
      streamerName: transactionConfig.streamerName,
      userName: transactionConfig.userName,
      payAmount: transactionConfig.payAmount,
      description: '',
      paymentNo: '',
      token: null,
      additionalParams: '',
      uniqueToken: ''
    };

    return this.http.get<any>(url, {params});
  }

  public performYtSearch(userToken: string, search: string): Observable<YtSongItems> {
    const url = `${environment.url}/add-song/searchYouTube`;

    const formData = new FormData();
    formData.append('clientId', userToken);
    formData.append('query', search);

    return this.http.post<any>(url, formData);
    //mock
    // const mockData1 = {
    //   id: {
    //     videoId: 'abc123'
    //   },
    //   snippet: {
    //     title: 'Mock Song 1. Mock Song 1. Mock Song 1. Mock Song 1. ',
    //     description: 'This is a mock song description 1',
    //     thumbnails: {
    //       default: {
    //         url: 'https://i.ytimg.com/an/6A-Z0jDKemh9-CwGbj5yog/featured_channel.jpg?v=5d04ac74'
    //       }
    //     }
    //   }
    // };
    //
    // const mockData2 = {
    //   id: {
    //     videoId: 'def456'
    //   },
    //   snippet: {
    //     title: 'Mock Song 2Mock Song 2Mock Song 2',
    //     description: 'This is a mock song description 2',
    //     thumbnails: {
    //       default: {
    //         url: 'https://i.ytimg.com/an/6A-Z0jDKemh9-CwGbj5yog/featured_channel.jpg?v=5d04ac74'
    //       }
    //     }
    //   }
    // };
    //
    // const mockData3 = {
    //   id: {
    //     videoId: 'ghi789'
    //   },
    //   snippet: {
    //     title: 'Mock Song 3Mock Song 3Mock Song 3Mock Song 3Mock Song ',
    //     description: 'This is a mock song description 3',
    //     thumbnails: {
    //       default: {
    //         url: 'https://i.ytimg.com/an/6A-Z0jDKemh9-CwGbj5yog/featured_channel.jpg?v=5d04ac74'
    //       }
    //     }
    //   }
    // };
    // return of([mockData1, mockData2, mockData3]);

    // return this.http.post<any>(url, formData);
  }

}
